/* eslint-disable camelcase */

import { useMemo } from 'react';
import { get } from '@hotjar/webapp/domains/common/settings';
import type { FeatureGroup } from '@hotjar/webapp/domains/revenue/plan/types';

type SimplePlan = { name: FeatureGroup | undefined; tier: number };

/**
 * Return the lowest tier plan a feature is available on, null if not available on any.
 * @param featureName Name of feature.
 * @deprecated use useTierForGate instead
 */
export function usePlanForFeature(featureName: string): FeatureGroup | undefined {
  return useMemo(() => {
    if (!featureName) {
      throw new Error('usePlanForFeature: You must specify a feature name to use this hook.');
    }
    let lowestPlan: SimplePlan = { name: undefined, tier: -1 };
    const { plans = [] } = get() ?? {};

    // Object.entries and typescript are not really friends: https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    Object.entries(plans).forEach(([planName, plan]) => {
      if (
        plan.features.includes(featureName) &&
        (lowestPlan.name === undefined || plan.tier < lowestPlan.tier)
      ) {
        lowestPlan = {
          name: planName as FeatureGroup,
          tier: plan.tier,
        };
      }
    });

    return lowestPlan?.name;
  }, [featureName]);
}
